import React from 'react'
import { getImage, GatsbyImage } from 'gatsby-plugin-image'

const Card = ({ frontmatter }) => (
  <div className="my-8 max-w-md mx-auto bg-white rounded shadow-md overflow-hidden md:max-w-2xl">
    <div className="md:flex">
      <div className="md:flex-shrink-0">
        <GatsbyImage
          className="h-48 w-full object-cover md:w-48 m-4"
          alt="Artifact"
          image={getImage(frontmatter.thumbnail)}
        />
      </div>
      <div className="p-8">
        <p className="block mt-1 text-lg leading-tight font-medium text-black hover:underline">{frontmatter.title}</p>
        <p className="mt-2 text-gray-500">{frontmatter.description}</p>
      </div>
    </div>
  </div>
)

export default Card
